const LayerBackSvg = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14362_31117)">
      <path
        d="M1.56249 5.72922H9.89582V15.6251H7.814C7.62377 15.6249 7.43714 15.6769 7.27436 15.7754C7.11157 15.8738 6.97885 16.0149 6.8906 16.1834C6.80234 16.352 6.76191 16.5414 6.7737 16.7313C6.7855 16.9212 6.84906 17.1042 6.95749 17.2605L11.6424 24.0301C11.7384 24.1688 11.8666 24.2821 12.0159 24.3603C12.1653 24.4386 12.3314 24.4795 12.5 24.4795C12.6686 24.4795 12.8347 24.4386 12.9841 24.3603C13.1334 24.2821 13.2616 24.1688 13.3575 24.0301L18.0425 17.2605C18.1508 17.1041 18.2142 16.9212 18.226 16.7313C18.2377 16.5415 18.1972 16.3521 18.109 16.1836C18.0208 16.0152 17.8881 15.8741 17.7254 15.7756C17.5627 15.6771 17.3762 15.6251 17.186 15.6251H15.1042V5.72922H23.4375C23.7137 5.7289 23.9784 5.61905 24.1737 5.42377C24.369 5.22849 24.4788 4.96372 24.4792 4.68755V1.56255C24.4788 1.28638 24.369 1.02162 24.1737 0.826334C23.9784 0.631052 23.7137 0.521204 23.4375 0.520887L1.56249 0.520887C1.28632 0.521204 1.02155 0.631052 0.82627 0.826334C0.630988 1.02162 0.521139 1.28638 0.520821 1.56255V4.68755C0.521139 4.96372 0.630988 5.22849 0.82627 5.42377C1.02155 5.61905 1.28632 5.7289 1.56249 5.72922Z"
        fill="black"
        fillOpacity="0.95"
      />
      <path
        d="M1.56249 12.5L8.85416 12.5V7.29167L1.56249 7.29167C1.28632 7.29198 1.02155 7.40183 0.826271 7.59711C0.630989 7.7924 0.52114 8.05716 0.520823 8.33333V11.4583C0.52114 11.7345 0.630989 11.9993 0.826271 12.1946C1.02155 12.3898 1.28632 12.4997 1.56249 12.5Z"
        fill="#878787"
      />
      <path
        d="M23.4375 7.29167L16.1458 7.29167V12.5L23.4375 12.5C23.7137 12.4997 23.9784 12.3898 24.1737 12.1946C24.369 11.9993 24.4788 11.7345 24.4792 11.4583V8.33333C24.4788 8.05716 24.369 7.7924 24.1737 7.59711C23.9784 7.40183 23.7137 7.29198 23.4375 7.29167Z"
        fill="#878787"
      />
    </g>
  </svg>
);

export default LayerBackSvg;
